// import {
//     apiRequest,
//     acmanajerialList,
//     acmanajerialActive,
//     acmanajerialInactive
// } from "../../../../../services/adapters/kepegawaian/Accompetence"
import {apiRequest,HollydayList,HollydayInactive} from "../../../../../services/adapters/master/hollydayService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", HollydayList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    // fetchRowTable = async (query, cancelToken) => {
    //     return await apiRequest("get", acmanajerialList, {
    //         cancelToken: cancelToken,
    //         params: query
    //     }, true)
    // }

    fetchInactive = async (query) => {
        return await apiRequest("post", HollydayInactive, {
            body: query
        }, true)
    }

    // fetchActive = async (query) => {
    //     return await apiRequest("post", acmanajerialActive, {
    //         body: query
    //     }, true)
    // }
}

export default DataTableRepository